import { css } from 'aphrodite'
import PropTypes from 'prop-types'
import React from 'react'

import { withI18n } from '@thebeansgroup/i18n'
import { Button, UnstyledButton } from '@thebeansgroup/sb_ui/ctas'
import CloseIcon from '@thebeansgroup/sb_ui/icons/close_icon'
import ModalPortal from '@thebeansgroup/sb_ui/modal_portal'
import { Body, Title1 } from '@thebeansgroup/sb_ui/typography'
import Colours from '@thebeansgroup/ui_style_helpers/colours'

import SSOHeader from '../../../images/sso_header.svg'

import styles from './styles'

const SSODisabledModal = ({
  visible,
  t,
  handleClick,
  handleCloseClick,
  ssoMethod
}) => {
  const renderHeader = () => (
    <>
      <div className={css(styles.closeButtonContainer)}>
        <UnstyledButton onClick={handleCloseClick}>
          <CloseIcon colour={Colours('white', '300')} />
        </UnstyledButton>
      </div>
      <SSOHeader />
    </>
  )

  const renderBody = () => (
    <div className={css(styles.bodyContainer)}>
      <Title1
        component='h1'
        colour={Colours('liquorice', '500')}
      >
        {t('m_coming_soon')}
      </Title1>
      <Body
        component='div'
        colour={Colours('grey', '400')}
      >
        <div className={css(styles.text)}>
          {t('m_add_password', { sso_method: ssoMethod })}
        </div>
      </Body>
      <div className={css(styles.button)}>
        <Button
          onClick={handleClick}
          text={t('a_add_password')}
          fullWidth
          inline
        />
      </div>
    </div>
  )

  return (
    <ModalPortal
      visible={visible}
      onDismiss={handleCloseClick}
    >
      <div className={css(styles.container)}>
        {renderHeader()}
        {renderBody()}
      </div>
    </ModalPortal>
  )
}

SSODisabledModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleCloseClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  ssoMethod: PropTypes.string.isRequired
}

export default withI18n(SSODisabledModal)
